<template>
  <div>
    <!-- 1.sms인증 폼 -->
    <SmsSend
      v-if="step === 'sms'"
      :userData="userData"
      @completeCertify="completeCertify"
    />

    <!-- 2.비밀번호 변경 폼 -->
    <div v-if="step === 'changePassword'">
      <PasswordForm ref="refPasswordForm" :userData="userData" />
      <div class="bottom-btn">
        <v-btn
          color="primary"
          x-large
          depressed
          block
          rounded
          @click="changePassword"
          >비밀번호 변경</v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import SmsSend from "./SmsSend.vue";
import PasswordForm from "@/_bayer/signUp/comp/userForm/comp/PasswordForm.vue";
const modelService = require("@/utils/dataModel.js");

export default {
  components: {
    SmsSend,
    PasswordForm,
  },
  data() {
    return {
      step: "sms",
      // step: "changePassword",
      userData: modelService.userModel(),
      // 변경할 비번 데이터
      reqData: {
        endpoint: "changePassword",
        userCell: "", // sms인증한 사용자 cell
        code: "", // sms 전송받은 문자코드
        password: "", // 변경된 비번
      },
    };
  },
  methods: {
    completeCertify(reqData) {
      this.step = "changePassword";
      this.reqData.userCell = reqData.userCell;
      this.reqData.code = reqData.code;
      setTimeout(() => {
        this.$refs.refPasswordForm.$refs.refPassword.focus();
      }, 500);
    },
    changePassword() {
      console.log("", this.userData);
      this.reqData.password = this.userData.password;
      this.saveDataPreLoginQuery(this.reqData).then((res) => {
        if (res === undefined) return;
        this.$helper.showTostMessage(
          "",
          "회원로그인 비밀번호가 변경되었습니다.",
          "success"
        );
        this.$router.push("/login");
      });
    },
    ...mapActions(["saveDataPreLoginQuery"]),
  },
};
</script>
<style lang="scss">
.v-list-item__title {
  font-size: 14px;
  font-weight: bold;
  padding: 0 15px 5px;
  color: $primary-color;
  .asterisk {
    color: $text-red;
  }
}
</style>